module.exports = __webpack_public_path__ + "static/img/2025年历-6.3e45e2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025年历-6.png
// module id = JK2e
// module chunks = 3